export const errorToJSON = error => ({stack: error.stack, message: error.message});
